var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("skp-breadcrumbs", {
          on: {
            "page-title": function(val) {
              return (_vm.pageTitle = val)
            }
          }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [
          _vm._v("Service Bulletin - Mobile (English) Create")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit" }, [_vm._v("Basic Info.")]),
        _vm._v(" "),
        _c("table", { staticClass: "create_table" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _vm._m(1),
              _vm._v(" "),
              _c("td", [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.create.REG_DT,
                        expression: "create.REG_DT"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100",
                    attrs: { type: "text", placeholder: "", readonly: "" },
                    domProps: { value: _vm.create.REG_DT },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.create, "REG_DT", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("td", [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.create.REG_USER_ID,
                        expression: "create.REG_USER_ID"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100",
                    attrs: { type: "text", placeholder: "", readonly: "" },
                    domProps: { value: _vm.create.REG_USER_ID },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.create, "REG_USER_ID", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(3),
              _vm._v(" "),
              _c("td", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.create.TYPE1,
                        expression: "create.TYPE1"
                      }
                    ],
                    staticClass: "slt_white w100p",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.create,
                            "TYPE1",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        function($event) {
                          _vm.create.TYPE2 = ""
                        }
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "Guide" } }, [
                      _vm._v("Guide")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "Bulletin" } }, [
                      _vm._v("Bulletin")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("td", [
                _vm.create.TYPE1 === "Guide"
                  ? _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.create.TYPE2,
                            expression: "create.TYPE2"
                          },
                          { name: "validation", rawName: "v-validation" }
                        ],
                        ref: "TYPE2G",
                        staticClass: "slt_white w100p",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.create,
                              "TYPE2",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Select Inquiry type")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Common" } }, [
                          _vm._v("Common")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "IMEI" } }, [
                          _vm._v("IMEI")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Policy / Process" } }, [
                          _vm._v("Policy / Process")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "SW Tool" } }, [
                          _vm._v("SW Tool")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "Jig / Equipment" } }, [
                          _vm._v("Jig / Equipment")
                        ]),
                        _vm._v(" "),
                        _c(
                          "option",
                          { attrs: { value: "Training Material" } },
                          [_vm._v("Training Material")]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.create.TYPE1 === "Bulletin"
                  ? _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.create.TYPE2,
                              expression: "create.TYPE2"
                            }
                          ],
                          ref: "TYPE2B",
                          staticClass: "slt_white w49",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.create,
                                "TYPE2",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Select Inquiry type")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.bulletinType2List, function(item) {
                            return _c(
                              "option",
                              { key: item, domProps: { value: item } },
                              [_vm._v(_vm._s(item))]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.create.NTYPE2,
                            expression: "create.NTYPE2"
                          }
                        ],
                        staticClass: "text_input w49",
                        attrs: { type: "text" },
                        domProps: { value: _vm.create.NTYPE2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.create, "NTYPE2", $event.target.value)
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(5),
              _vm._v(" "),
              _c("td", [
                _c("label", { staticClass: "radiobox-wrap mr10" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.create.URGENCY_YN,
                        expression: "create.URGENCY_YN"
                      }
                    ],
                    attrs: { type: "radio", name: "", value: "N" },
                    domProps: { checked: _vm._q(_vm.create.URGENCY_YN, "N") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.create, "URGENCY_YN", "N")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "radio-icon" }),
                  _vm._v(" "),
                  _c("em", [_vm._v("Normal")])
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "radiobox-wrap" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.create.URGENCY_YN,
                        expression: "create.URGENCY_YN"
                      }
                    ],
                    attrs: { type: "radio", name: "", value: "Y" },
                    domProps: { checked: _vm._q(_vm.create.URGENCY_YN, "Y") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.create, "URGENCY_YN", "Y")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "radio-icon" }),
                  _vm._v(" "),
                  _c("em", { staticClass: "txt_red" }, [_vm._v("Urgency")])
                ])
              ]),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _c("td", [
                _c("label", { staticClass: "radiobox-wrap mr10" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.create.NEED_REPROCESS,
                        expression: "create.NEED_REPROCESS"
                      }
                    ],
                    attrs: { type: "radio", name: "", value: "Y" },
                    domProps: {
                      checked: _vm._q(_vm.create.NEED_REPROCESS, "Y")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.create, "NEED_REPROCESS", "Y")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "radio-icon" }),
                  _vm._v(" "),
                  _c("em", { staticClass: "txt_red" }, [_vm._v("Need")])
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "radiobox-wrap" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.create.NEED_REPROCESS,
                        expression: "create.NEED_REPROCESS"
                      }
                    ],
                    attrs: { type: "radio", name: "", value: "N" },
                    domProps: {
                      checked: _vm._q(_vm.create.NEED_REPROCESS, "N")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.create, "NEED_REPROCESS", "N")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "radio-icon" }),
                  _vm._v(" "),
                  _c("em", [_vm._v("Not Need")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(7),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.create.TITLE,
                        expression: "create.TITLE"
                      },
                      { name: "validation", rawName: "v-validation" },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    ref: "title",
                    staticClass: "text_input w100",
                    attrs: { type: "text", minlength: "5", maxlength: "200" },
                    domProps: { value: _vm.create.TITLE },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.create, "TITLE", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Tag Info")]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.create.TAG_INFO,
                        expression: "create.TAG_INFO"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100",
                    attrs: {
                      type: "text",
                      minlength: "2",
                      maxlength: "200",
                      value: ""
                    },
                    domProps: { value: _vm.create.TAG_INFO },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.create, "TAG_INFO", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(8),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "userlevel", attrs: { colspan: "3" } },
                [
                  _c("div", { staticClass: "check_wrap w260p" }, [
                    _c("label", { staticClass: "checkbox-wrap mr5" }, [
                      _c("input", {
                        ref: "checkboxUserLevelAll",
                        attrs: { type: "checkbox" },
                        on: {
                          change: function($event) {
                            return _vm.onUserLevelAllCheckboxChange($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("i", { staticClass: "check-icon" })
                    ]),
                    _vm._v(" "),
                    _c("em", [_vm._v("All")])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.userLevelList, function(item) {
                    return _c(
                      "div",
                      { key: item.CODE_ID, staticClass: "check_wrap w260p" },
                      [
                        _c("label", { staticClass: "checkbox-wrap mr5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkedUserLevelList,
                                expression: "checkedUserLevelList"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: item.CODE_ID,
                              checked: Array.isArray(_vm.checkedUserLevelList)
                                ? _vm._i(
                                    _vm.checkedUserLevelList,
                                    item.CODE_ID
                                  ) > -1
                                : _vm.checkedUserLevelList
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.checkedUserLevelList,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = item.CODE_ID,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.checkedUserLevelList = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.checkedUserLevelList = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.checkedUserLevelList = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.onUserLevelCheckboxChange($event)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "check-icon" })
                        ]),
                        _vm._v(" "),
                        _c("em", [
                          _vm._v(
                            _vm._s(item.CODE_ID) +
                              "(" +
                              _vm._s(item.CODE_NAME) +
                              ")"
                          )
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(
                  "\n                        Subsidary\n                        "
                ),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "ico_pen",
                    on: { click: _vm.selectSubsidiaryPopup }
                  },
                  [_vm._v("pen아이콘")]
                )
              ]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c(
                  "ul",
                  { staticClass: "ul_list" },
                  _vm._l(_vm.selectedSubsidiaryList, function(item) {
                    return _c(
                      "li",
                      { key: item, staticClass: "userlevel_txt" },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(9),
              _vm._v(" "),
              _c("td", { staticClass: "userlevel", attrs: { colspan: "3" } }, [
                _vm.availableCountryList.length === 0
                  ? _c("div", [_vm._v("Please select subsidiary first.")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.availableCountryList.length > 0
                  ? _c("div", { staticClass: "check_wrap w260p" }, [
                      _c("label", { staticClass: "checkbox-wrap mr5" }, [
                        _c("input", {
                          ref: "checkboxCountryAll",
                          attrs: { type: "checkbox" },
                          on: {
                            change: function($event) {
                              return _vm.onCountryAllCheckboxChange($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "check-icon" })
                      ]),
                      _vm._v(" "),
                      _c("em", [_vm._v("All")])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "max_scrollbar" },
                  _vm._l(_vm.availableCountryList, function(item) {
                    return _c(
                      "div",
                      { key: item.CODE_ID, staticClass: "check_wrap w260p" },
                      [
                        _c("label", { staticClass: "checkbox-wrap mr5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkedCountryList,
                                expression: "checkedCountryList"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: item.CDCODE,
                              checked: Array.isArray(_vm.checkedCountryList)
                                ? _vm._i(_vm.checkedCountryList, item.CDCODE) >
                                  -1
                                : _vm.checkedCountryList
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.checkedCountryList,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = item.CDCODE,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.checkedCountryList = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.checkedCountryList = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.checkedCountryList = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.onCountryCheckboxChange($event)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "check-icon" })
                        ]),
                        _vm._v(" "),
                        _c("em", [_vm._v(_vm._s(item.CDDESC))])
                      ]
                    )
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(10),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "3" } },
                [
                  _c("cross-editor", {
                    attrs: {
                      editorId: "bulletin",
                      editorData: _vm.create.CONTENT
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v("Attachment")]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "no_padding", attrs: { colspan: "3" } },
                [
                  _c("innorix-upload", {
                    attrs: {
                      id: _vm.getUploadId,
                      name: _vm.getUploadId,
                      uploadId: _vm.getUploadId,
                      onlyUpload: _vm.onlyUpload,
                      attachList: _vm.attachFileSeq
                    },
                    on: { files: _vm.setAttachFiles }
                  })
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }, [
          _c(
            "a",
            {
              staticClass: "btn_white",
              attrs: { href: "javascript:" },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "hhpServiceBulletin" })
                }
              }
            },
            [_vm._v("List")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "btn_right" }, [
            _c(
              "a",
              {
                staticClass: "btn_white",
                attrs: { href: "javascript:" },
                on: {
                  click: function($event) {
                    return _vm.btnSaveDraft()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVEDRAFT")))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn_blue",
                attrs: { href: "javascript:" },
                on: {
                  click: function($event) {
                    return _vm.onSaveClick()
                  }
                }
              },
              [_vm._v("Save")]
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        Date\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        Register\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Type\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("Subtype\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        Urgency\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v(
        "\n                        Need Translation\n                        "
      ),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        Title\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        User Level\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v(
        "\n                        Country / Region\n                        "
      ),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", [
      _vm._v("\n                        Contents\n                        "),
      _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-478ec323", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478ec323","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinCreate.vue
// module id = noJ0
// module chunks = 0